<template>
  <div>
    <div class="discover-inside w-100 h-100 d-flex">
      <nav class="sidebar position-relative" :style="sidebarBackground">
        <h3 class="title position-absolute font-weight-bold">
          {{ $t('discover.header.tags.discover') }}
        </h3>
        <ul class="w-100">
          <li
            v-for="(option, index) in discoverData"
            :key="index"
            class="w-100"
            :class="{
              space: index === 9,
              'pr-0 d-flex align-items-center': option.new,
              selected: optionSelected === index
            }"
          >
            <div
              class="option-container d-inline-flex"
              @mouseover="hoverItem($event, { ...option, index })"
            >
              <Link
                modal-name="discover-modal"
                :internal-link="option.internalLink"
                :translate-link="option.translateLink"
                :value="option.value"
                :link="option.link"
                :link-subscriptor="option.linkSubscriptor"
                :link-url-builder="option.linkUrlBuilder"
              />
              <BadgeNew v-if="option.new" :height="20" class="ml-1" />
            </div>
          </li>
        </ul>
      </nav>
      <section class="content-section position-relative" :style="background">
        <nav class="discover-nav position-absolute">
          <ul class="d-flex align-items-center">
            <li>
              <nuxt-link
                :to="$trailingSlash(localePath('our-graphics'))"
                :style="fontColorStyle"
                @click.native="hideModalGaEvent($trailingSlash(localePath('our-graphics')))"
              >
                {{ $t('discover.header.tags.latest') }}
              </nuxt-link>
            </li>
            <li>
              <nuxt-link
                :to="$trailingSlash(localePath('featured-vectors'))"
                :style="fontColorStyle"
                @click.native="hideModalGaEvent($trailingSlash(localePath('featured-vectors')))"
              >
                {{ $t('discover.header.tags.featured') }}
              </nuxt-link>
            </li>
            <li>
              <nuxt-link
                :to="$trailingSlash(localePath('trending-vectors'))"
                :style="fontColorStyle"
                @click.native="hideModalGaEvent($trailingSlash(localePath('trending-vectors')))"
              >
                {{ $t('discover.header.tags.trending') }}
              </nuxt-link>
            </li>
            <li>
              <nuxt-link
                :to="$trailingSlash(localePath('categories'))"
                :style="fontColorStyle"
                @click.native="hideModalGaEvent($trailingSlash(localePath('categories')))"
              >
                {{ $t('discover.header.tags.categories') }}
              </nuxt-link>
            </li>
            <li>
              <nuxt-link
                :to="$urlBuilder('plans', { keyword: 'discover' })"
                :style="fontColorStyle"
                @click.native="hideModalGaEvent($urlBuilder('plans'))"
              >
                {{ $t('discover.header.tags.pricing') }}
              </nuxt-link>
            </li>
            <li>
              <a
                href="https://www.vexels.com/blog/"
                :style="fontColorStyle"
                target="_blank"
                rel="noopener noreferrer"
                @click="hideModalGaEvent('https://www.vexels.com/blog/')"
              >
                {{ $t('discover.header.tags.blog') }}
              </a>
            </li>
          </ul>
        </nav>
        <div v-if="justOpened" class="content w-100 h-100">
          <b-row align-h="end" class="h-100">
            <b-col col lg="6" xl="7" class="d-flex align-items-end">
              <p class="initial-title-bottom">{{ $t(contentTitle) }}</p>
            </b-col>
          </b-row>
        </div>
        <Content
          v-else
          :content-items="contentItems"
          :content-title="contentTitle"
          :font-color="fontColor"
          :box-hover-background-color="boxHoverBackgroundColor"
          :content-img-position="contentImgPosition"
          :footer-links="footerLinks"
          :see-all-link="seeAllLink"
          :see-all-text="seeAllText"
          :internal-link="internalLink"
          :niches="niches"
          :only-text="onlyText"
          :description="description"
          :options="discoverData"
          :option-selected="optionSelected"
        />
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Content from './Content';
import BadgeNew from '@/components/UI/Badges/New';
import Link from './Link';
import discoverData from './discoverData.json';

export default {
  name: 'Discover',
  components: {
    Content,
    BadgeNew,
    Link
  },
  data() {
    return {
      isShow: false,
      justOpened: true,
      background: '',
      sidebarBackground: '',
      contentItems: [],
      footerLinks: [],
      seeAllLink: '',
      seeAllText: '',
      internalLink: false,
      contentTitle: '',
      contentImgPosition: '',
      fontColor: '#242424',
      boxHoverBackgroundColor: '',
      niches: false,
      onlyText: false,
      description: '',
      randomNumberBackground: null,
      optionSelected: null,
      discoverData: discoverData
    };
  },
  computed: {
    ...mapGetters('discover', ['getInitialBackgrounds', 'getDiscoverLink']),
    fontColorStyle() {
      return `color:${this.fontColor};--color-line:${this.fontColor};`;
    }
  },
  mounted() {
    this.loadInitialBackground();
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId == 'discover-modal') {
        this.justOpened = true;
        this.optionSelected = null;
      }
    });
  },
  methods: {
    mapTranslateLinks(linksArray) {
      let translatedLinks = linksArray.map((currentLink) => {
        return {
          ...currentLink,
          link: this.getDiscoverLink({
            linkUrlBuilder: currentLink.linkUrlBuilder,
            link: currentLink.link,
            translateLink: currentLink.translateLink,
            urlBuilder: this.$urlBuilder,
            trailingSlash: this.$trailingSlash,
            localePath: this.localePath
          })
        };
      });
      return translatedLinks;
    },
    hoverItem(
      e,
      {
        title,
        imgPosition,
        fontColor,
        niches,
        onlyText,
        description,
        boxHoverBackgroundColor,
        content,
        links,
        seeAllText,
        internalLink,
        translateLink,
        link,
        linkSubscriptor,
        linkUrlBuilder,
        contentLink,
        contentLinkUrlBuilder,
        background,
        index
      }
    ) {
      this.optionSelected = index;
      this.justOpened = false;
      this.contentTitle = title;
      this.fontColor = fontColor;
      this.background = 'background: ' + background + ';--color-line:' + this.fontColor + ';';
      this.sidebarBackground =
        'background-color: ' + (background == '#ffffff' ? '#f1f1f1' : '#ffffff') + ';';
      this.contentImgPosition = imgPosition ? imgPosition : '';
      this.boxHoverBackgroundColor = boxHoverBackgroundColor;
      this.contentItems = content ? content : [];
      this.footerLinks = links ? this.mapTranslateLinks(links || []) : [];
      const linkParams = {
        link,
        linkSubscriptor,
        linkUrlBuilder,
        translateLink,
        localePath: this.localePath,
        urlBuilder: this.$urlBuilder,
        trailingSlash: this.$trailingSlash,
        isSubscriptor: this.$auth.user?.isSubscriptor
      };
      this.seeAllLink = this.setSeeAllLink(contentLinkUrlBuilder, contentLink, linkParams);
      this.internalLink = internalLink;
      this.niches = niches;
      this.onlyText = onlyText;
      this.description = description;
      this.seeAllText = seeAllText;
    },
    setSeeAllLink(contentLinkUrlBuilder, contentLink, linkParams) {
      if (contentLinkUrlBuilder) {
        const { type, path, keyword } = contentLinkUrlBuilder;
        contentLinkUrlBuilder = this.$urlBuilder(type, {
          path,
          keyword
        });
      }
      return contentLinkUrlBuilder || contentLink || this.getDiscoverLink(linkParams);
    },
    async loadInitialBackground() {
      await this.$store.dispatch('discover/LOAD_INITIAL_BACKGROUND');
      this.justOpened = true;
      this.setInitialBackground();
    },
    setInitialBackground() {
      if (this.getInitialBackgrounds.length > 0) {
        let random = Math.floor(Math.random() * this.getInitialBackgrounds.length);
        if (random === this.randomNumberBackground && this.getInitialBackgrounds.length > 1) {
          return this.setInitialBackground();
        }
        this.randomNumberBackground = random;
        let { title, background, imgPosition, fontColor } = this.getInitialBackgrounds[random];
        this.background = 'background: ' + background + ';';
        this.sidebarBackground =
          'background-color: ' + (background == '#ffffff' ? '#f1f1f1' : '#ffffff') + ';';
        this.contentImgPosition = imgPosition ? imgPosition : '';
        this.fontColor = fontColor;
        this.contentTitle = title;
      }
    },
    hideModalGaEvent(url) {
      this.$bvModal.hide('discover-modal');
      this.$ga.event('Discover', 'Click Discover Block', url);
    }
  }
};
</script>

<style lang="scss">
@media (min-width: #{$screen-xl-min}) {
  .discover-main-content {
    position: absolute;
    z-index: 2;
  }
  .discover-image {
    display: flex;
    position: absolute;
    z-index: 1;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    justify-content: flex-end;
  }

  .discover-image img {
    width: 125%;
    @include xl2 {
      width: 120%;
    }
  }

  .discover-image-center {
    align-items: center;
  }

  .discover-image-end {
    align-items: flex-end;
  }

  #discover-modal___BV_modal_header_ {
    border: none;
    position: absolute;
    right: -15px;
  }
  #discover-modal {
    > .modal-dialog {
      max-width: initial;
      width: 80%;
      @include xl2 {
        width: 90%;
      }
      > .modal-content {
        min-height: 90vh;
        max-height: 90vh;
        height: auto;
        border: none;
        > .modal-body {
          padding: 0;
          display: grid;
          min-height: 90vh;
          max-height: 90vh;
        }
      }
    }
    .hover-section {
      > .title-container {
        margin-top: 0px;
        padding: 20px 0 0;
        @include xl2 {
          height: 160px !important;
        }
        > .title {
          @include xl3 {
            font-size: 35px !important;
          }
          @include xl2 {
            font-size: 30px !important;
          }
        }
        > .description-hover {
          line-height: 47px;
          font-size: 44px;
          @include xl3 {
            font-size: 30px !important;
          }
          @include xl2 {
            line-height: 40px;
            font-size: 25px !important;
          }
        }
      }

      .flex-content {
        justify-content: normal !important;
      }
    }
    .discover-inside {
      height: 90vh !important;
      > .sidebar {
        width: 300px;
        border-radius: 15px 0 0 15px;
        z-index: 5;
        .space {
          margin-top: 3em;
          @include xl2 {
            margin-top: 1em;
          }
        }
        > .title {
          font-size: 1.75rem;
          top: 50px;
          left: 25px;
        }
        > ul {
          height: calc(100% - 50px);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 35px 0 25px;
          margin: 50px 0 0;
          overflow-y: auto;
          > li {
            display: flex;
            align-items: center;
            height: 45px;
            list-style: none;
            color: #242424;
            padding: 5px 0 5px 25px;
            font-size: 16px;
            @include xl2 {
              height: 39px;
              font-size: 14px;
            }
            transition: padding 0.5s;
            a {
              color: #242424;
            }
            .option-container:hover {
              font-size: 24px;
              @include xl2 {
                font-size: 20px;
              }
              a {
                color: black;
                font-weight: 500;
              }
            }
          }
          > li.selected .option-container {
            font-size: 24px;
            @include xl2 {
              font-size: 20px;
            }
            a {
              font-weight: 500;
            }
          }
        }
      }
      > .content-section {
        width: calc(100% - 300px);
        background-color: #eaeaea;
        padding-left: 65px;
        background-size: cover !important;
        border-radius: 0 15px 15px 0;
        padding-top: 95px;
        overflow: hidden;
        @include xl2 {
          padding-top: 60px;
        }
        > button.close {
          right: 15px;
          top: 10px;
          z-index: 2;
        }
        > .content {
          background-size: contain;
          background-position: right;
          background-repeat: no-repeat;
          position: relative;
          transition: background-position 0.5s;
          section {
            > .title-container {
              > .title {
                font-size: 45px;
                font-weight: 500;
                @include xl {
                  font-size: 40px !important;
                }
                @include lg {
                  font-size: 30px !important;
                }
                @include md {
                  font-size: 25px !important;
                }
                @include sm {
                  font-size: 20px !important;
                }
              }
            }
            > .title-container-only-text {
              > .title {
                font-size: 65px;
                font-weight: 500;
              }
            }
            > .carousel-container {
              height: 300px;
            }
            .niches-subtitle {
              color: #000;
              font-weight: 500;
              font-size: 25px;
              margin-top: 55px;
              @include xl2 {
                margin-top: 0;
              }
            }
          }
          .footer-content {
            bottom: 50px;
            height: auto;
            z-index: 5;
            > .text {
              font-size: 21px;
              @include xl2 {
                font-size: 16px;
              }
              margin-bottom: 9px;
              display: block;
              color: #4d4d4d;
              position: relative;
              &::after {
                content: ' ';
                height: 2px;
                width: 0%;
                background-color: var(--color-line);
                position: absolute;
                bottom: 0;
                left: 0;
                transition: 0.2s width linear;
              }
              &:hover {
                &::after {
                  content: ' ';
                  width: 100%;
                  transition: 0.2s width linear;
                }
              }
            }
          }
          .initial-title-bottom {
            margin-bottom: 100px;
            margin-right: 10%;
            font-weight: 500;
            font-size: 45px;
            line-height: 1.2;
          }
          .seasonal-info {
            align-items: flex-start !important;
            justify-content: flex-end;
            flex-direction: column;
            padding: 0 60px 60px;
            color: white;
            @include xl2 {
              padding: 0 30px 40px;
            }
          }
        }
      }
    }
    .discover-nav {
      position: absolute;
      right: 50px;
      top: 25px;
      z-index: 2;
      > ul {
        display: flex;
        align-items: center;
        width: min-content;
        padding: 0;
        > li {
          list-style: none;
          padding: 10px 15px;
          color: #808080;
          cursor: pointer;
          font-size: 16px;
          @include xl2 {
            font-size: 14px;
          }
          > a {
            text-decoration: none;
            position: relative;
            &::after {
              content: ' ';
              height: 2px;
              width: 0%;
              background-color: var(--color-line);
              position: absolute;
              bottom: 0;
              left: 0;
              transition: 0.2s width linear;
            }
            &:hover {
              &::after {
                content: ' ';
                width: 100%;
                transition: 0.2s width linear;
              }
            }
          }
          &:hover {
            color: #000000;
          }
        }
      }
    }
  }
  .discover-text {
    color: #888888;
    width: 75%;
    margin-top: 35px;
    @include xl2 {
      margin-top: 0;
    }
  }
}
</style>
